import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import JobRoutes from './JobRoutes'
import 'react-table/react-table.css'

class JobFunctions extends Component {
  constructor(props) {
    super(props)

    this.state = {
      detailShowing: true,
      currentTable: 'Job Attachments',
      confirmDirty: false,
      autoCompleteResult: []
    }
  }

  toggleDetails() {
    this.setState({
      detailShowing: !this.state.detailShowing
    })
  }

  render() {
    let currentTaskForm = ''
    return (
      <div>
        {currentTaskForm}
        <div className="col-xs-8 backgroundWhite">
          <JobRoutes {...this.props} />
        </div>
        <br />
      </div>
    )
  }
}

export default withRouter(JobFunctions)



// WEBPACK FOOTER //
// ./src/components/JobFunctions.js